"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryUnityList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var financialLecture_1 = require("../../model/financialLecture");
var service_1 = require("../../../library/base/service");
var QueryUnityList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(QueryUnityList, _super);
    function QueryUnityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '元宇宙微讲堂列表';
        _this.code = '600100';
        _this.desc = "\u5143\u5B87\u5B99\u5FAE\u8BB2\u5802\u5217\u8868";
        _this.requestParams = new financialLecture_1.QueryListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return QueryUnityList;
}(service_1.BaseService));
exports.QueryUnityList = QueryUnityList;
//# sourceMappingURL=queryUnityList.js.map